// extracted by mini-css-extract-plugin
module.exports = {"room":"rooms_room__lJnS0","uploadoverlay":"rooms_uploadoverlay__SxI4_","deviceselection":"rooms_deviceselection__3PrPr","unblocker":"rooms_unblocker__12fTc"};